import { hexToRgba } from '@/utils';
import { makeAutoObservable } from 'mobx';

interface Theme {
    mainColor: string;
    secondaryColor: string;
    rootSize: string;
    mainColorAlpha: Record<string, string>; // 用于存储透明度色值
    successColor: string;
}

export class ThemeStore {
    theme: Theme;

    constructor() {
        // 初始化默认主题
        const defaultSuccessColor = '#03C785';
        const defaultMainColor = '#ff6e00';
        const defaultSecondaryColor = 'rgba(255, 110, 0, 0.15)';
        const defaultRootSize = '16px';

        // 初始化 mainColorAlpha
        const mainColorAlpha: Record<string, string> = {};
        for (let i = 9; i >= 1; i--) {
            const opacity = i / 10;
            mainColorAlpha[`alpha${i}`] = hexToRgba(defaultMainColor, opacity);
        }

        this.theme = {
            mainColor: defaultMainColor,
            secondaryColor: defaultSecondaryColor,
            rootSize: defaultRootSize,
            mainColorAlpha, // 设置默认的透明度色值
            successColor: defaultSuccessColor,
        };

        makeAutoObservable(this);
    }

    setTheme(theme: Theme) {
        this.theme = {
            ...this.theme,
            ...theme,
        };
    }
}
